<template>
  <div
    class="modal fade"
    ref="appointmentModal"
    id="appointmentModal"
    tabindex="-1"
    aria-labelledby="appointmentModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="appointmentModalLabel">
            {{ $t("modal.title") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>{{ $t("modal.message") }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            {{ $t("modal.close") }}
          </button>
          <a :href="appointmentUrl" target="_blank" class="btn btn-primary">{{
            $t("modal.bookNow")
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentModal",
  data() {
    return {
      appointmentUrl: "https://diversecarenow.as.me/schedule/6a240cde",
      modalInstance: null,
    };
  },
  mounted() {
    this.modalInstance = new window.bootstrap.Modal(
      this.$refs.appointmentModal
    );
    this.modalInstance.show();

    this.$refs.appointmentModal.addEventListener("hidden.bs.modal", () => {
      setTimeout(() => {
        this.modalInstance.show();
      }, 120000); // 2 minutes
    });
  },
  methods: {
    closeModal() {
      this.modalInstance.hide();
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 15px;
}
.modal-header {
  border-bottom: none;
}
.modal-footer {
  border-top: none;
}
</style>
